var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageHeader',{attrs:{"title":_vm.$t('trees'),"icon":"mdi-pine-tree"}},[_vm._v(" WIP ")])
}
var staticRenderFns = []

export { render, staticRenderFns }